import { UserService } from 'src/app/core/service/user.service';
import { Component, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { TaskService } from '../../core/service/task.service';
import { MessengerService, MessageSubject } from 'src/app/core/service/messenger.service';
import { Group } from 'src/app/user/model/user';
import { sortBy } from 'lodash';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { TextProcessor } from 'src/app/core/utility/text.processor';
import { Channel } from 'src/app/channel/model/channel';
import { ChannelService } from 'src/app/core/service/channel.service';
import { CaseService } from 'src/app/core/service/case.service';

@Component({
  selector: 'app-task-assign',
  templateUrl: './task-assign.component.html',
  styleUrls: ['./task-assign.component.scss']
})
export class TaskAssignComponent implements OnChanges
{
  @Input() public task;
  @Input() public dialogOpened: boolean;
  @Output() public closing = new EventEmitter();
  @Output() public save = new EventEmitter();

  public assignee = { name: null, username: null };
  public staff: Array<{ name: string; username: string; enabled: boolean; inRegistration: boolean }> = [];
  public staffFiltered: Array<{ name: string; username: string }> = [];
  public channel: Channel;
  public group: Group;
  public shortTaskName = '';

  /**
   * Current search term entered from a comboxbox
   */
  public searchTerm: string;

  constructor(private userService: UserService,
    private taskService: TaskService,
    private channelService: ChannelService,
    private messengerService: MessengerService,
    private messageHandlerService: MessageHandlerService,
    private caseService: CaseService,) { }

  public ngOnChanges(): void
  {
    if (this.task != null)
    {
      this.shortTaskName = TextProcessor.truncateText(this.task.name, 35);
      this.assignee = { name: this.task.assigneeName, username: this.task.assignee };

      if (this.task.channelId > 0)
      {
        this.channelService.getChannel(this.task.channelId).subscribe({
          next: (data) =>
          {
            this.channel = data;
            this.userService.getUserByMember(this.task.memberId).subscribe({
              next: (user) =>
              {
                this.userService.getUsersByChannelGroups(this.channel.id).subscribe({
                  next: (users) =>
                  {
                    this.staff = users.map(p => ({
                      name: p.name, username: p.username, enabled: p.enabled,
                      inRegistration: p.inRegistration
                    }));
                    if (user !== null)
                    {
                      this.staff.push({
                        name: user.name, username: user.username, enabled: user.enabled,
                        inRegistration: user.inRegistration
                      });
                    }
                    this.addMissingAssigneeToStaffList();
                    this.staffFilter('');
                    if (this.task?.caseId > 0)
                    {
                      this.caseService.getCaseDetails(this.task.caseId, 'OPEN', true).subscribe({
                        next: (caseData) =>
                        {
                          if (caseData.createdByUsername !== 'SYSTEM') 
                          {
                            // check if case.createdBy already in the Channel Assigned Staff or Assigned Staff Groups                        
                            const existingUser = this.staff.filter(u => u.username === caseData.createdByUsername)[0];
                            if (existingUser === undefined) 
                            {
                              this.userService.getUserByUsername(caseData.createdByUsername).subscribe({
                                next: (caseUser) =>
                                {
                                  this.staff.push({
                                    name: caseData.createdBy, username: caseData.createdByUsername, enabled: caseUser.enabled,
                                    inRegistration: caseUser.inRegistration
                                  });
                                  this.staffFilter('');
                                }
                              });
                            }
                          }
                        }
                      });
                    }
                  }
                });
              }
            });
          }
        });
      }
      // Ad hoc-task
      else
      {
        this.userService.getUserByAdHocTask(this.task.id).subscribe({
          next: (user) =>
          {
            this.userService.getCacheUsersByRole('ROLE_CARE_COORDINATOR').subscribe({
              next: (users) =>
              {
                this.staff = users.map(p => ({
                  name: p.name, username: p.username, enabled: p.enabled,
                  inRegistration: p.inRegistration
                }));
                if (user !== null)
                {
                  this.staff.push({
                    name: user.name, username: user.username, enabled: user.enabled,
                    inRegistration: user.inRegistration
                  });
                }
                this.addMissingAssigneeToStaffList();
                this.staffFilter('');
              }
            });
          }
        });
      }
    }
  }

  public addMissingAssigneeToStaffList(): void
  {
    // Current selected assignee must be part of the staff list
    if (this.assignee && this.assignee.username && this.staff.findIndex(x => x.username === this.assignee.username) === -1)
    {
      this.staff.push({
        name: this.assignee.name, username: this.assignee.username, enabled: true, inRegistration: false
      });
    }
  }

  public assign(): void
  {
    this.task.assignee = this.assignee.username;
    this.taskService.assignTask(this.task.id, this.assignee.username).subscribe({
      next: () =>
      {
        this.messageHandlerService.displaySuccess('TASK-ASSIGNEE-UPDATED-SUCCESSFULLY');
        this.messengerService.sendMessage(new MessageSubject('taskHistoryUpdated'));
        this.dialogOpened = false;
        this.save.emit(this.assignee);
      }
    });
  }

  public closeDialog(): void
  {
    this.closing.emit();
  }

  /**
   * Filter handler for case manager assign dropdown.
   *
   * @param value User input.
   */
  public staffFilter(value: string): void
  {
    this.searchTerm = value;
    this.staffFiltered = sortBy(this.staff.filter(p => p.name.toLowerCase().includes(value.toLowerCase())), ['name']);
  }

  /**
   * Check if user from dropdown is disabled or enabled.
   *
   * @returns boolean
   */
  public itemDisabled(itemArgs: { dataItem: any; index: number }): boolean
  {
    return !itemArgs.dataItem.enabled && !itemArgs.dataItem.inRegistration;
  }
}
